import type * as api from '@gitbook/api-client';
import { PaletteButton } from '@gitbook/react-uikit';
import { Icon } from '@gitbook/spine-icons';
import { type ButtonProps, DialogRoot, useDialogTriggerState } from '@gitbook/spine-react';

import { SpaceCreationDialog } from '../../Space';
import type { CreateSiteSectionDialogProps } from './CreateSiteSectionDialog';
import { type UseAddSectionsToGroupProps, useAddSectionsToGroup } from './useAddSectionsToGroup';

interface AddSiteSectionToGroupButtonProps
    extends Omit<UseAddSectionsToGroupProps, 'createSiteSectionDialogTrigger'>,
        Omit<CreateSiteSectionDialogProps, 'inSiteSectionGroup' | 'space'>,
        Pick<ButtonProps, 'className' | 'label' | 'size'> {
    siteStructure: api.SiteStructure;
    siteSectionGroup: api.SiteSectionGroup;
}

export function AddSiteSectionToGroupButton(props: AddSiteSectionToGroupButtonProps) {
    const { className, label, size, siteSectionGroup } = props;
    const createSiteSectionDialogTrigger = useDialogTriggerState();
    const addSectionsToGroup = useAddSectionsToGroup({
        ...props,
        createSiteSectionDialogTrigger,
    });
    return (
        <>
            <DialogRoot {...createSiteSectionDialogTrigger.rootProps}>
                <SpaceCreationDialog
                    target={{
                        type: 'siteSection',
                        siteStructure: props.siteStructure,
                        props: { ...props, inSiteSectionGroup: siteSectionGroup },
                    }}
                    organizationId={props.organization.id}
                />
            </DialogRoot>
            <PaletteButton
                palette={() => addSectionsToGroup(siteSectionGroup)}
                kind="secondary"
                leadingIcon={Icon.AddSiteSection}
                className={className}
                label={label}
                size={size}
            />
        </>
    );
}
